import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ParallaxLayer from "./parallax_layer.js";
import { ReactComponent as IconCountry } from '../../media/icons/country.svg';
import { ReactComponent as IconLocation } from '../../media/icons/location.svg';


export default class Hero2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            searchbox_input: "",
            searchbox_input_active: false,
            searchbox_dropdown: [],
            highlightedIndex: -1,
            scrollY: 0,
            scrollYFactor: 0.6,
            parallax_layers: [
                {
                    number: 1,
                    url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero_6.webp",
                    factor: "0.6"
                },
                {
                    number: 2,
                    url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero_5.webp",
                    factor: "0.5"
                },
                {
                    number: 3,
                    url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero_4.webp",
                    factor: "0.4"
                },
                {
                    number: 4,
                    url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero_3.webp",
                    factor: "0.3"
                },
                {
                    number: 5,
                    url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero_2.webp",
                    factor: "0.2"
                },
                {
                    number: 6,
                    url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero_1.webp",
                    factor: "0.1"
                }
            ]
        };

        this.inputField = React.createRef();

        this.clickInput = this.clickInput.bind(this);
        this.focusInput = this.focusInput.bind(this);
        this.blurInput = this.blurInput.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.filterLocations = this.filterLocations.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }


    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }


    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }


    handleScroll = () => {
        this.setState({ scrollY: window.scrollY });
    }


    clickInput() {
        this.inputField.current.focus();
    }


    focusInput() {
        this.setState({
            searchbox_input_active: true
        });
    }


    blurInput() {
        this.setState({
            searchbox_input_active: false
        });
    }


    handleKeyDown(e) {
        const { searchbox_dropdown, highlightedIndex } = this.state;
        if (!searchbox_dropdown.length) return;

        switch (e.key) {
            case "ArrowDown":
                e.preventDefault();
                this.setState({
                    highlightedIndex: Math.min(highlightedIndex + 1, searchbox_dropdown.length - 1)
                });
                break;
            case "ArrowUp":
                e.preventDefault();
                this.setState({
                    highlightedIndex: Math.max(highlightedIndex - 1, 0)
                });
                break;
            case "Enter":
                e.preventDefault();
                if (highlightedIndex >= 0) {
                    const loc = searchbox_dropdown[highlightedIndex];
                    const url =
                        "/trips?" +
                        (loc.country ? "country=" + loc.country + "&" : "") +
                        (loc.city ? "city=" + loc.city : "");
                    this.props.goToPage(url);
                }
                break;
            default:
                break;
        }
    }


    handleInputChange(event) {
        var value = event.target.value;
        this.setState({
            searchbox_input: value
        });
        if (value.length >= 2) {
            this.filterLocations(value);
        } else {
            this.setState({
                searchbox_dropdown: []
            });
        };
    }


    filterLocations(searchTerm) {
        try {
            var locations = this.props.locations;
            const lowerSearchTerm = searchTerm.toLowerCase();
            var dropdown = [];
            var length = 20;
            var counter = 0;
            for (const country in locations) {
                if (counter <= length) {
                    if (country.toLowerCase().includes(lowerSearchTerm)) {
                        dropdown.push({
                            country: country
                        });
                        counter++;
                    }
                }
            }
            for (const country in locations) {
                for (const city of locations[country]) {
                    if (counter <= length) {
                        if (city.toLowerCase().includes(lowerSearchTerm)) {
                            dropdown.push({
                                country: country,
                                city: city
                            });
                            counter++;
                        }
                    }
                }
            }
            this.setState({
                searchbox_dropdown: dropdown,
                highlightedIndex: dropdown.length ? 0 : -1
            });
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not filter location data. Please check the URL and try again.";
            this.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Home_filterLocations");
        }
    }


    getlocationcode(country) {
        try {
            return this.props.locationcodes[country];
        } catch (error) {
            return false;
        }
    }


    render() {

        return (
            <div className="content-container hero-container">
                {this.state.parallax_layers.map((layer) => (
                    <ParallaxLayer key={layer.number} number={layer.number} url={layer.url} factor={layer.factor} scrollY={this.state.scrollY} />
                ))}
                <div className="hero__background hero__background--overlay" style={{ transform: `translateY(${this.state.scrollY * this.state.scrollYFactor}px)` }}></div>
                <div className="content-wrapper--wide hero-wrapper">
                    
                    <div className="hero2__title-container">
                        <div className="hero__title">
                            <h1 className="hero__title__static-content text-herotitle text-color-light">
                                {"Expert itineraries for unforgettable trips"}
                            </h1>
                        </div>
                    </div>

                    <div className="hero2__title-container">
                        <div className="hero__title">
                            <h2 className="hero__title__static-content text-subtitle text-color-light">
                                {"Access travel plans created by people who know the destination best, with day-by-day itineraries, pictures, maps, and insider tips"}
                            </h2>
                        </div>
                    </div>

                    <div className="hero2__title-container">
                        <div className="hero__title">
                            <div className="hero__title__static-content text-color-light">
                                {"Built by locals, influencers, and hospitality pros • free and paid options • new itineraries added weekly"}
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        )
    }
}
